import { graphql } from "gql";

const INTERNAL_ADMIN_TAG_LIST_QUERY = graphql(`
  query InternalAdminTagList(
    $organizationId: ID!
    $input: InternalAdminTagListInput!
  ) {
    internalAdminTagList(organizationId: $organizationId, input: $input) {
      ...InternalAdminTag
    }
  }
`);

export default INTERNAL_ADMIN_TAG_LIST_QUERY;
